import { COLORS } from "assets";

export const fieldSx = { height: 48, minHeight: 48 };
export const iconSx = { fontSize: 20, color: COLORS.surface.secondaryText };
export const cameraModalWidth = 680;

export const sectionTitleSx = {
  color: COLORS.surface.primaryText,
  fontWeight: 600,
  fontSize: 14,
  mb: 1.25
};

export const sectionHintSx = {
  color: COLORS.surface.secondaryText,
  fontSize: 12,
  lineHeight: 1.5,
  mt: 0.75
};
